import { render, staticRenderFns } from "./CreatePlusTemplateListTop.vue?vue&type=template&id=77665063&scoped=true&"
import script from "./CreatePlusTemplateListTop.vue?vue&type=script&lang=js&"
export * from "./CreatePlusTemplateListTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77665063",
  null
  
)

export default component.exports